export const associationCampaign = {
  id: 'amigas-2026-2027',
  eyebrow: 'CAMPAÑA AMIGAS 2026–2027',
  title: '¡Queremos contar contigo!',
  subtitle: 'Hazte Amiga de la cultura menstrual y cíclica',
  paragraphs: [
    'Necesitamos tu apoyo para seguir cuidando, defendiendo y ampliando los derechos menstruales, sexuales y (no)reproductivos. Más que nunca, queremos seguir construyendo juntas una cultura menstrual crítica, diversa y transformadora.',
    'Hazte Amiga por 26 € al año y ayúdanos a mantener viva La Vida en Rojo.'
  ],
  ctaLabel: 'Quiero hacerme Amiga',
  ctaUrl: 'https://www.lavidaenrojo.org/hazte-amiga',
  activeFrom: '2026-01-01',
  activeUntil: '2027-12-31'
}

const validateCampaignDate = (dateString) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString)
  if (!match) throw new Error(`Invalid campaign date: ${dateString}`)

  const [, year, month, day] = match
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  if (
    date.getFullYear() !== Number(year) ||
    date.getMonth() !== Number(month) - 1 ||
    date.getDate() !== Number(day)
  ) {
    throw new Error(`Invalid campaign date: ${dateString}`)
  }

  return dateString
}

export const isAssociationCampaignActive = (now = new Date()) => {
  if (Number.isNaN(now.getTime())) throw new Error('Invalid current date')

  const today = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0')
  ].join('-')
  const activeFrom = validateCampaignDate(associationCampaign.activeFrom)
  const activeUntil = validateCampaignDate(associationCampaign.activeUntil)

  return today >= activeFrom && today <= activeUntil
}
